<template>
  <div class="expected-delivery-date-change-form">
    <div class="title" :class="isApply ? 'title_apply' : ''">
      客期变更填写
      <template v-if="isDetail">
        <el-tag class="approve_tag" :class="tagColor" type="warning" size="medium">
          {{ changeStatusEnum[status] }}
        </el-tag>
        <span>ID: {{ applicationId }}</span>
      </template>
    </div>
    <el-form v-if="isApply" ref="form" label-width="auto" :rules="rules" :model="formState">
      <div class="display_flex_space_between">
        <el-form-item prop="type" label="变更类型:">
          <el-select
            v-model="formState.type"
            placeholder="请选择变更类型"
            class="input-width"
            @change="handleChangeType"
          >
            <el-option v-for="item in changeType" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item prop="scenarios" label="变更场景:">
          <el-select
            v-model="formState.scenarios"
            placeholder="请输入变更场景"
            class="input-width"
            :disabled="!formState.type"
          >
            <el-option v-for="item in changeScene" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
      </div>
      <div class="margin_bottom_30">
        <el-form-item prop="description" label="变更说明:">
          <el-input
            v-model="formState.description"
            type="textarea"
            :placeholder="'请输入文字：\n1、提前客期请填写项目紧急重要性、不及时交付的影响、最迟接受的供货时间，以便统筹协调资源；\n2、延迟客期请说明延迟原因'"
            rows="8"
            maxlength="500"
            :disabled="!formState.type"
          />
        </el-form-item>
      </div>
    </el-form>
    <el-descriptions
      v-if="isDetail"
      size="medium"
      :column="4"
      :colon="false"
    >
      <el-descriptions-item label="变更类型:" :span="1">
        {{ typeLabel ? typeLabel : '-' }}
      </el-descriptions-item>
      <el-descriptions-item label="变更类型:" :span="1">
        {{ scenariosLabel ? scenariosLabel : '-' }}
      </el-descriptions-item>
      <el-descriptions-item :span="2" />
      <el-descriptions-item label="变更说明:" :span="4">
        {{ formState.description || '-' }}
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import { deepCopy } from '@/libs/util';

export default {
  name: 'ExpectedDeliveryDateChangeForm',
  emits: ['changeCeddType'],
  props: {
    // 是否是详情
    isDetail: {
      type: Boolean,
      default: false
    },
    // 是否是申请
    isApply: {
      type: Boolean,
      default: false
    },
    // 申请单的id
    applicationId: {
      type: String,
      default: ''
    },
    // 申请单的状态
    status: {
      type: [String, Number],
      default: ''
    }
  },
  data () {
    return {
      formState: {
        type: void 0, // 变更类型
        scenarios: void 0, // 变更场景
        description: void 0 // 变更说明
      },
      typeLabel: '',
      scenariosLabel: '',
      // 必填项
      rules: {
        type: [
          { required: true, message: '请选择变更类型', trigger: 'change' }
        ],
        scenarios: [
          { required: true, message: '请选择变更场景', trigger: 'change' }
        ],
        description: [
          { required: true, message: '请输入变更说明', trigger: 'change' }
        ]
      }
    };
  },
  computed: {
    tagColor () {
      // 10:待审批 20:已驳回 30:已通过
      if (Number(this.status) === 10) {
        return 'approve_tag_wait';
      }
      if (Number(this.status) === 20) {
        return 'approve_tag_reject';
      }
      if (Number(this.status) === 30) {
        return 'approve_tag_approve';
      }
      return '';
    },
    // 根据变更类型返回对应的变更场景
    changeScene () {
      if (this.formState.type === 'delay') {
        return this.changeDelay;
      }
      if (this.formState.type === 'advance') {
        return this.changeAdvance;
      }
      return [];
    },
    // 根据变更类型返回对应的变更场景的对象格式 { value: label }
    changeSceneEnum () {
      if (this.formState.type === 'delay') {
        // p: 上一次循环返回出来值, 这里默认值为 {}; n 当前循环到的元素;
        return this.changeDelay.reduce((p, n) => ({ ...p, [n.value]: n.label }), {});
      }
      if (this.formState.type === 'advance') {
        // p: 上一次循环返回出来值, 这里默认值为 {}; n 当前循环到的元素;
        return this.changeAdvance.reduce((p, n) => ({ ...p, [n.value]: n.label }), {});
      }
      return {};
    },
    changeTypeEnum () {
      // p: 上一次循环返回出来值, 这里默认值为 {}; n 当前循环到的元素;
      return this.changeType.reduce((p, n) => ({ ...p, [n.value]: n.label }), {});
    },
    changeStatusEnum () {
      // p: 上一次循环返回出来值, 这里默认值为 {}; n 当前循环到的元素;
      return this.changeStatus.reduce((p, n) => ({ ...p, [n.value]: n.label }), {});
    },
    ...mapState({
      // 变更类型
      changeType: state => state.enumeration.changeType,
      // 提前的变更场景
      changeAdvance: state => state.enumeration.changeAdvance,
      // 延迟的变更场景
      changeDelay: state => state.enumeration.changeDelay,
      // 状态下拉
      changeStatus: state => state.enumeration.changeStatus
    })
  },
  methods: {
    setDefaultFormData (base, data) {
      this.typeLabel = base.typeLabel;
      this.scenariosLabel = base.scenariosLabel;
      this.formState.type = data.type;
      this.formState.scenarios = data.scenarios;
      this.formState.description = data.description;
      if (this.isEdit) {
        this.$nextTick(() => {
          this.$refs.form.clearValidate();
        });
      }
    },

    getFormData () {
      let isPass = false;
      this.$refs.form.validate((validate) => {
        isPass = validate;
      });
      if (!isPass) return false;
      return deepCopy(this.formState);
    },

    handleChangeType (val) {
      // 变化的时候清空场景
      this.formState.scenarios = undefined;
      this.formState.description = undefined;
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
      this.$emit('changeCeddType', val);
    }
  },
  mounted () {
  }
};
</script>
<style scoped lang="scss">
.expected-delivery-date-change-form {
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #383838;
    margin-bottom: 6px;
  }
  .approve_tag {
    font-size: 14px;
    margin-right: 12px;
    margin-left: 8px;
  }
  .input-width {
    max-width: 270px;
    width: 100%;
  }
  .display_flex_space_between {
    width: 778px;
    max-width: 778px;
    display: flex;
    justify-content: space-between;
  }
  :deep(.el-descriptions__table) {
    table-layout: fixed;
  }
  :deep(.el-textarea__inner) {
    width: 700px;
    resize: none;
    font-size: 14px;
    &::placeholder {
      color: #a6a6a6;
      text-align: left;
    }
  }
}
:deep(.el-descriptions-item__cell) {
  font-size: 14px;
  padding: 10px 0;
}
:deep(.el-tag) {
  border-color: transparent;
}
.approve_tag_wait {
  background-color: #fff6ed !important;
  color: #ff8d1a !important;
}
.approve_tag_reject {
  background-color: #fff3f3 !important;
  color: #cf3838 !important;
}
.approve_tag_approve {
  background-color: #edfdf3 !important;
  color: #43cf7c !important;
}
.title_apply {
  margin-bottom: 16px !important;
}
.display_flex_space_between {
  margin-bottom: 12px;
}
.margin_bottom_30 {
  margin-bottom: 30px;
}
</style>
